import React from 'react';

import { QuestionCard } from './card';
import { useConversationContext } from '../../../conversation_context';

import type { AskUserQuestionsToolCall } from './types';
import type { InlineToolCall } from '../../types';
import type { Message } from '../../../types';

export function PinnedQuestions() {
  const { answerQuestions, busy, dismissQuestions, messages } = useConversationContext();

  const toolCall = openQuestions(messages);
  if (!toolCall) {
    return null;
  }

  const { answerPath, questions } = toolCall.metadata;

  return (
    <div className="ai-assistant-pinned flex-shrink-0 px-3 pb-2">
      <QuestionCard
        busy={busy}
        key={answerPath}
        questions={questions}
        onDismiss={() => void dismissQuestions(answerPath)}
        onSubmit={answers => void answerQuestions(answerPath, answers)}
      />
    </div>
  );
}

function openQuestions(messages: Message[]) {
  const lastUserIndex = messages.reduce((last, { role }, index) => (role === 'user' ? index : last), -1);

  for (let index = lastUserIndex + 1; index < messages.length; index += 1) {
    const open = (messages[index].inlineToolCalls || []).find(isOpenQuestion);
    if (open) {
      return open;
    }
  }

  return null;
}

function isOpenQuestion(toolCall: InlineToolCall): toolCall is InlineToolCall & AskUserQuestionsToolCall {
  return toolCall.name === 'ask_user_questions' && !toolCall.metadata.answers && !toolCall.metadata.dismissed;
}
